import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private isDarkTheme = signal(false);

  readonly isDarkTheme$ = this.isDarkTheme.asReadonly();

  constructor() {
    // Check system preference and localStorage
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;

    const shouldUseDark = savedTheme === "dark" || (!savedTheme && prefersDark);
    this.setTheme(shouldUseDark);
  }

  toggleTheme(): void {
    this.setTheme(!this.isDarkTheme());
  }

  setTheme(isDark: boolean): void {
    this.isDarkTheme.set(isDark);

    // Update document class (using 'dark' instead of 'dark-theme' for Tailwind compatibility)
    if (isDark) {
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("dark-theme");
    } else {
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.remove("dark-theme");
    }

    // Save preference
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }
}
